import { render, staticRenderFns } from "./BranchPage.vue?vue&type=template&id=cc8414c6&scoped=true&"
import script from "./BranchPage.vue?vue&type=script&lang=js&"
export * from "./BranchPage.vue?vue&type=script&lang=js&"
import style0 from "./BranchPage.vue?vue&type=style&index=0&id=cc8414c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8414c6",
  null
  
)

export default component.exports